const {createBoolean, createObject, createString, traversePropertiesArray, traversePropertiesString, valueIf} = require('../../shared');

module.exports.health = function (appData, formData, outData, formDataKey) {

  if (!outData.error && !createObject(appData, "health", {})) {
    outData.error = "Cannot create health info";
  }

  if (!outData.error && !createString(appData.health, "feet", traversePropertiesString(formData, [formDataKey, 'heightFt']), true)) {
    outData.error = "Cannot set health height in feet";
  }

  if (!outData.error && !createString(appData.health, "inches", traversePropertiesString(formData, [formDataKey, 'heightIn']), true)) {
    outData.error = "Cannot set health height in inches";
  }

  if (!outData.error && !createString(appData.health, "weight", traversePropertiesString(formData, [formDataKey, 'weight']), true)) {
    outData.error = "Cannot set health weight";
  }

  const hasPhysician = valueIf(traversePropertiesString(formData, [formDataKey, 'hasPhysician']) !== "1", false, true);
  if (!outData.error && !createString(appData.health, "noPhysician", !hasPhysician, true)) {
    outData.error = "Cannot set health dwiConviction Date";
  }
  if (hasPhysician) {

    if (!outData.error && !createString(appData.health, "physicianName", traversePropertiesString(formData, [formDataKey, 'physicianName']), true)) {
      outData.error = "Cannot set health physician name";
    }

    if (!outData.error && !createString(appData.health, "physicianPhone", traversePropertiesString(formData, [formDataKey, 'physicianPhone']), true)) {
      outData.error = "Cannot set health physician phone";
    }

    if (!outData.error && !createString(appData.health, "lastVisitDate", traversePropertiesString(formData, [formDataKey, 'physicianVisit']), true)) {
      outData.error = "Cannot set health physician lastVisitDate";
    }

    if (!outData.error && !createString(appData.health, "lastVisitReason", traversePropertiesString(formData, [formDataKey, 'physicianReason']), true)) {
      outData.error = "Cannot set health physician lastVisitReason";
    }

    if (!outData.error && !createString(appData.health, "physicianStreet", traversePropertiesString(formData, [formDataKey, 'physicianAddress']), true)) {
      outData.error = "Cannot set health physicianStreet";
    }

    if (!outData.error && !createString(appData.health, "physicianZip", traversePropertiesString(formData, [formDataKey, 'physicianZip']), true)) {
      outData.error = "Cannot set health physicianZip";
    }

  } else {

    if (!outData.error && !createString(appData.health, "physicianName", "", false)) {
      outData.error = "Cannot set health physician name";
    }

    if (!outData.error && !createString(appData.health, "physicianPhone", "", false)) {
      outData.error = "Cannot set health physician phone";
    }

    if (!outData.error && !createString(appData.health, "lastVisitDate", "", false)) {
      outData.error = "Cannot set health physician lastVisitDate";
    }

    if (!outData.error && !createString(appData.health, "lastVisitReason", "", false)) {
      outData.error = "Cannot set health physician lastVisitReason";
    }

    if (!outData.error && !createString(appData.health, "physicianStreet", "", false)) {
      outData.error = "Cannot set health physicianStreet";
    }

    if (!outData.error && !createString(appData.health, "physicianZip", "", false)) {
      outData.error = "Cannot set health physicianZip";
    }

  }

  if (!outData.error && !createString(appData.health, "dwiConviction", valueIf(traversePropertiesString(formData, [formDataKey, 'dwiConviction', 0, 'convictionDate']).length > 0, traversePropertiesString(formData, [formDataKey, 'dwiConviction', 0, 'convictionDate']), ""), false)) {
    outData.error = "Cannot set health dwiConviction Date";
  }

//Create Arrays
  if (!outData.error && !createObject(appData.health, "otherMedication", [])) {
    outData.error = "Cannot create health otherMedication info";
  }
  if (!outData.error && !createObject(appData.health, "everDeclined", [])) {
    outData.error = "Cannot create health everDeclined info";
  }
  if (!outData.error && !createObject(appData.health, "advice", [])) {
    outData.error = "Cannot create health advice info";
  }
  if (!outData.error && !createObject(appData.health, "disabilityPay", [])) {
    outData.error = "Cannot create health disabilityPay info";
  }
  if (!outData.error && !createObject(appData.health, "hiv", [])) {
    outData.error = "Cannot create health hiv info";
  }
  if (!outData.error && !createObject(appData.health, "anyDisease", [])) {
    outData.error = "Cannot create health anyDisease info";
  }
  if (!outData.error && !createObject(appData.health, "hospitalized", [])) {
    outData.error = "Cannot create health hospitalized info";
  }

  if (!outData.error) { //Medication
    const otherMedicationData = traversePropertiesArray(formData, [formDataKey, 'medicine']);
    otherMedicationData.some((otherMedicationFormData, index) => {
      const errorSection = 'medicine';
      let tempMed = {};
      const samePhysician = valueIf(traversePropertiesString(otherMedicationFormData, ['samePhysician']) === "Y", true, false);
      if (!outData.error && !createString(tempMed, "diagnosisDescription", traversePropertiesString(otherMedicationFormData, ['condition']), true)) {
        outData.error = "Cannot set diagnosisDescription " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "medication", traversePropertiesString(otherMedicationFormData, ['medication']), true)) {
        outData.error = "Cannot set medication " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "physicianName", valueIf(hasPhysician && samePhysician, appData.health.physicianName, traversePropertiesString(otherMedicationFormData, ['physicianName'])), true)) {
        outData.error = "Cannot set physicianName " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "physicianPhone", valueIf(hasPhysician && samePhysician, appData.health.physicianPhone, traversePropertiesString(otherMedicationFormData, ['physicianPhone'])), true)) {
        outData.error = "Cannot set physicianPhone " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "physicianStreet", valueIf(hasPhysician && samePhysician, appData.health.physicianStreet, traversePropertiesString(otherMedicationFormData, ['physicianAddress'])), true)) {
        outData.error = "Cannot set physicianStreet " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "physicianZip", valueIf(hasPhysician && samePhysician, appData.health.physicianZip, traversePropertiesString(otherMedicationFormData, ['physicianZip'])), true)) {
        outData.error = "Cannot set physicianZip " + errorSection + (index + 1);
      }
      if (outData.error) {
        return true;
      } else {
        appData.health.otherMedication.push(tempMed);
      }

    });
  }

  if (!outData.error) { //everDeclined
    const everDeclinedData = traversePropertiesArray(formData, [formDataKey, 'everDeclined']);
    everDeclinedData.some((everDeclinedFormData, index) => {
      const errorSection = 'everDeclined';
      let tempMed = {};
      const samePhysician = valueIf(traversePropertiesString(everDeclinedFormData, ['samePhysician']) === "Y", true, false);

      if (!outData.error && !createObject(tempMed, "why", traversePropertiesArray(everDeclinedFormData,['why']))) {
        outData.error = "Cannot create health why "+ errorSection + (index + 1);
      }

      if (!outData.error && !createString(tempMed, "diagnosisDescription", traversePropertiesString(everDeclinedFormData, ['condition']), true)) {
        outData.error = "Cannot set diagnosisDescription " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "medication", traversePropertiesString(everDeclinedFormData, ['medication']), true)) {
        outData.error = "Cannot set medication " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "diagnosisDate", traversePropertiesString(everDeclinedFormData, ['diagnosisDate']), true)) {
        outData.error = "Cannot set diagnosisDate " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "treatmentDate", traversePropertiesString(everDeclinedFormData, ['treatmentDate']), true)) {
        outData.error = "Cannot set treatmentDate " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "treatmentType", traversePropertiesString(everDeclinedFormData, ['treatmentType']), true)) {
        outData.error = "Cannot set treatmentType " + errorSection + (index + 1);
      }

      if (!outData.error && !createString(tempMed, "physicianName", valueIf(hasPhysician && samePhysician, appData.health.physicianName, traversePropertiesString(everDeclinedFormData, ['physicianName'])), true)) {
        outData.error = "Cannot set physicianName " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "lastVisitDate", valueIf(hasPhysician && samePhysician, appData.health.lastVisitDate, traversePropertiesString(everDeclinedFormData, ['physicianVisit'])), true)) {
        outData.error = "Cannot set lastVisitDate " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "lastVisitReason", valueIf(hasPhysician && samePhysician, appData.health.lastVisitReason, traversePropertiesString(everDeclinedFormData, ['physicianReason'])), true)) {
        outData.error = "Cannot set physicianPhone " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "physicianPhone", valueIf(hasPhysician && samePhysician, appData.health.physicianPhone, traversePropertiesString(everDeclinedFormData, ['physicianPhone'])), true)) {
        outData.error = "Cannot set physicianPhone " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "physicianStreet", valueIf(hasPhysician && samePhysician, appData.health.physicianStreet, traversePropertiesString(everDeclinedFormData, ['physicianAddress'])), true)) {
        outData.error = "Cannot set physicianStreet " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "physicianZip", valueIf(hasPhysician && samePhysician, appData.health.physicianZip, traversePropertiesString(everDeclinedFormData, ['physicianZip'])), true)) {
        outData.error = "Cannot set physicianZip " + errorSection + (index + 1);
      }
      if (outData.error) {
        return true;
      } else {
        appData.health.everDeclined.push(tempMed);
      }

    });
  }


  if (!outData.error) { //disabilityPay
    const disabilityPayData = traversePropertiesArray(formData, [formDataKey, 'disabilityPay']);
    disabilityPayData.some((disabilityPayFormData, index) => {
      const errorSection = 'disabilityPay';
      let tempMed = {};
      const samePhysician = valueIf(traversePropertiesString(disabilityPayFormData, ['samePhysician']) === "Y", true, false);

      if (!outData.error && !createString(tempMed, "diagnosisDescription", traversePropertiesString(disabilityPayFormData, ['condition']), true)) {
        outData.error = "Cannot set diagnosisDescription " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "medication", traversePropertiesString(disabilityPayFormData, ['medication']), true)) {
        outData.error = "Cannot set medication " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "diagnosisDate", traversePropertiesString(disabilityPayFormData, ['diagnosisDate']), true)) {
        outData.error = "Cannot set diagnosisDate " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "treatmentDate", traversePropertiesString(disabilityPayFormData, ['treatmentDate']), true)) {
        outData.error = "Cannot set treatmentDate " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "treatmentType", traversePropertiesString(disabilityPayFormData, ['treatmentType']), true)) {
        outData.error = "Cannot set treatmentType " + errorSection + (index + 1);
      }

      if (!outData.error && !createString(tempMed, "physicianName", valueIf(hasPhysician && samePhysician, appData.health.physicianName, traversePropertiesString(disabilityPayFormData, ['physicianName'])), true)) {
        outData.error = "Cannot set physicianName " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "lastVisitDate", valueIf(hasPhysician && samePhysician, appData.health.lastVisitDate, traversePropertiesString(disabilityPayFormData, ['physicianVisit'])), true)) {
        outData.error = "Cannot set lastVisitDate " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "lastVisitReason", valueIf(hasPhysician && samePhysician, appData.health.lastVisitReason, traversePropertiesString(disabilityPayFormData, ['physicianReason'])), true)) {
        outData.error = "Cannot set physicianPhone " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "physicianPhone", valueIf(hasPhysician && samePhysician, appData.health.physicianPhone, traversePropertiesString(disabilityPayFormData, ['physicianPhone'])), true)) {
        outData.error = "Cannot set physicianPhone " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "physicianStreet", valueIf(hasPhysician && samePhysician, appData.health.physicianStreet, traversePropertiesString(disabilityPayFormData, ['physicianAddress'])), true)) {
        outData.error = "Cannot set physicianStreet " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "physicianZip", valueIf(hasPhysician && samePhysician, appData.health.physicianZip, traversePropertiesString(disabilityPayFormData, ['physicianZip'])), true)) {
        outData.error = "Cannot set physicianZip " + errorSection + (index + 1);
      }
      if (outData.error) {
        return true;
      } else {
        appData.health.disabilityPay.push(tempMed);
      }

    });
  }

  if (!outData.error) { //hiv
    const hivData = traversePropertiesArray(formData, [formDataKey, 'hiv']);
    hivData.some((hivFormData, index) => {
      const errorSection = 'hiv';
      let tempMed = {};
      const samePhysician = valueIf(traversePropertiesString(hivFormData, ['samePhysician']) === "Y", true, false);

      if (!outData.error && !createString(tempMed, "diagnosisDescription", traversePropertiesString(hivFormData, ['condition']), true)) {
        outData.error = "Cannot set diagnosisDescription " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "medication", traversePropertiesString(hivFormData, ['medication']), true)) {
        outData.error = "Cannot set medication " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "diagnosisDate", traversePropertiesString(hivFormData, ['diagnosisDate']), true)) {
        outData.error = "Cannot set diagnosisDate " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "treatmentDate", traversePropertiesString(hivFormData, ['treatmentDate']), true)) {
        outData.error = "Cannot set treatmentDate " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "treatmentType", traversePropertiesString(hivFormData, ['treatmentType']), true)) {
        outData.error = "Cannot set treatmentType " + errorSection + (index + 1);
      }

      if (!outData.error && !createString(tempMed, "physicianName", valueIf(hasPhysician && samePhysician, appData.health.physicianName, traversePropertiesString(hivFormData, ['physicianName'])), true)) {
        outData.error = "Cannot set physicianName " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "lastVisitDate", valueIf(hasPhysician && samePhysician, appData.health.lastVisitDate, traversePropertiesString(hivFormData, ['physicianVisit'])), true)) {
        outData.error = "Cannot set lastVisitDate " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "lastVisitReason", valueIf(hasPhysician && samePhysician, appData.health.lastVisitReason, traversePropertiesString(hivFormData, ['physicianReason'])), true)) {
        outData.error = "Cannot set physicianPhone " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "physicianPhone", valueIf(hasPhysician && samePhysician, appData.health.physicianPhone, traversePropertiesString(hivFormData, ['physicianPhone'])), true)) {
        outData.error = "Cannot set physicianPhone " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "physicianStreet", valueIf(hasPhysician && samePhysician, appData.health.physicianStreet, traversePropertiesString(hivFormData, ['physicianAddress'])), true)) {
        outData.error = "Cannot set physicianStreet " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "physicianZip", valueIf(hasPhysician && samePhysician, appData.health.physicianZip, traversePropertiesString(hivFormData, ['physicianZip'])), true)) {
        outData.error = "Cannot set physicianZip " + errorSection + (index + 1);
      }
      if (outData.error) {
        return true;
      } else {
        appData.health.hiv.push(tempMed);
      }

    });
  }

  if (!outData.error) { //anyDisease
    const anyDiseaseData = traversePropertiesArray(formData, [formDataKey, 'anyDisease']);
    anyDiseaseData.some((anyDiseaseFormData, index) => {
      const errorSection = 'anyDisease';
      let tempMed = {};
      const samePhysician = valueIf(traversePropertiesString(anyDiseaseFormData, ['samePhysician']) === "Y", true, false);

      if (!outData.error && !createString(tempMed, "diagnosisDescription", traversePropertiesString(anyDiseaseFormData, ['condition']), true)) {
        outData.error = "Cannot set diagnosisDescription " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "medication", traversePropertiesString(anyDiseaseFormData, ['medication']), true)) {
        outData.error = "Cannot set medication " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "diagnosisDate", traversePropertiesString(anyDiseaseFormData, ['diagnosisDate']), true)) {
        outData.error = "Cannot set diagnosisDate " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "treatmentDate", traversePropertiesString(anyDiseaseFormData, ['treatmentDate']), true)) {
        outData.error = "Cannot set treatmentDate " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "treatmentType", traversePropertiesString(anyDiseaseFormData, ['treatmentType']), true)) {
        outData.error = "Cannot set treatmentType " + errorSection + (index + 1);
      }

      if (!outData.error && !createString(tempMed, "physicianName", valueIf(hasPhysician && samePhysician, appData.health.physicianName, traversePropertiesString(anyDiseaseFormData, ['physicianName'])), true)) {
        outData.error = "Cannot set physicianName " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "lastVisitDate", valueIf(hasPhysician && samePhysician, appData.health.lastVisitDate, traversePropertiesString(anyDiseaseFormData, ['physicianVisit'])), true)) {
        outData.error = "Cannot set lastVisitDate " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "lastVisitReason", valueIf(hasPhysician && samePhysician, appData.health.lastVisitReason, traversePropertiesString(anyDiseaseFormData, ['physicianReason'])), true)) {
        outData.error = "Cannot set physicianPhone " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "physicianPhone", valueIf(hasPhysician && samePhysician, appData.health.physicianPhone, traversePropertiesString(anyDiseaseFormData, ['physicianPhone'])), true)) {
        outData.error = "Cannot set physicianPhone " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "physicianStreet", valueIf(hasPhysician && samePhysician, appData.health.physicianStreet, traversePropertiesString(anyDiseaseFormData, ['physicianAddress'])), true)) {
        outData.error = "Cannot set physicianStreet " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "physicianZip", valueIf(hasPhysician && samePhysician, appData.health.physicianZip, traversePropertiesString(anyDiseaseFormData, ['physicianZip'])), true)) {
        outData.error = "Cannot set physicianZip " + errorSection + (index + 1);
      }
      if (outData.error) {
        return true;
      } else {
        appData.health.anyDisease.push(tempMed);
      }

    });
  }


  if (!outData.error) { //hospitalized
    const hospitalizedData = traversePropertiesArray(formData, [formDataKey, 'hospitalized']);
    hospitalizedData.some((hospitalizedFormData, index) => {
      const errorSection = 'hospitalized';
      let tempMed = {};
      const samePhysician = valueIf(traversePropertiesString(hospitalizedFormData, ['samePhysician']) === "Y", true, false);

      if (!outData.error && !createString(tempMed, "diagnosisDescription", traversePropertiesString(hospitalizedFormData, ['condition']), true)) {
        outData.error = "Cannot set diagnosisDescription " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "medication", traversePropertiesString(hospitalizedFormData, ['medication']), true)) {
        outData.error = "Cannot set medication " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "diagnosisDate", traversePropertiesString(hospitalizedFormData, ['diagnosisDate']), true)) {
        outData.error = "Cannot set diagnosisDate " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "treatmentDate", traversePropertiesString(hospitalizedFormData, ['treatmentDate']), true)) {
        outData.error = "Cannot set treatmentDate " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "treatmentType", traversePropertiesString(hospitalizedFormData, ['treatmentType']), true)) {
        outData.error = "Cannot set treatmentType " + errorSection + (index + 1);
      }

      if (!outData.error && !createString(tempMed, "physicianName", valueIf(hasPhysician && samePhysician, appData.health.physicianName, traversePropertiesString(hospitalizedFormData, ['physicianName'])), true)) {
        outData.error = "Cannot set physicianName " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "lastVisitDate", valueIf(hasPhysician && samePhysician, appData.health.lastVisitDate, traversePropertiesString(hospitalizedFormData, ['physicianVisit'])), true)) {
        outData.error = "Cannot set lastVisitDate " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "lastVisitReason", valueIf(hasPhysician && samePhysician, appData.health.lastVisitReason, traversePropertiesString(hospitalizedFormData, ['physicianReason'])), true)) {
        outData.error = "Cannot set physicianPhone " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "physicianPhone", valueIf(hasPhysician && samePhysician, appData.health.physicianPhone, traversePropertiesString(hospitalizedFormData, ['physicianPhone'])), true)) {
        outData.error = "Cannot set physicianPhone " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "physicianStreet", valueIf(hasPhysician && samePhysician, appData.health.physicianStreet, traversePropertiesString(hospitalizedFormData, ['physicianAddress'])), true)) {
        outData.error = "Cannot set physicianStreet " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "physicianZip", valueIf(hasPhysician && samePhysician, appData.health.physicianZip, traversePropertiesString(hospitalizedFormData, ['physicianZip'])), true)) {
        outData.error = "Cannot set physicianZip " + errorSection + (index + 1);
      }
      if (outData.error) {
        return true;
      } else {
        appData.health.hospitalized.push(tempMed);
      }

    });
  }

  if (!outData.error) { //advice
    const adviceData = traversePropertiesArray(formData, [formDataKey, 'advice']);
    adviceData.some((adviceFormData, index) => {
      const errorSection = 'advice';
      let tempMed = {};
      const samePhysician = valueIf(traversePropertiesString(adviceFormData, ['samePhysician']) === "Y", true, false);

      if (!outData.error && !createString(tempMed, "diagnosisDescription", traversePropertiesString(adviceFormData, ['condition']), true)) {
        outData.error = "Cannot set diagnosisDescription " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "medication", traversePropertiesString(adviceFormData, ['medication']), true)) {
        outData.error = "Cannot set medication " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "diagnosisDate", traversePropertiesString(adviceFormData, ['diagnosisDate']), true)) {
        outData.error = "Cannot set diagnosisDate " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "treatmentDate", traversePropertiesString(adviceFormData, ['treatmentDate']), true)) {
        outData.error = "Cannot set treatmentDate " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "treatmentType", traversePropertiesString(adviceFormData, ['treatmentType']), true)) {
        outData.error = "Cannot set treatmentType " + errorSection + (index + 1);
      }

      if (!outData.error && !createString(tempMed, "physicianName", valueIf(hasPhysician && samePhysician, appData.health.physicianName, traversePropertiesString(adviceFormData, ['physicianName'])), true)) {
        outData.error = "Cannot set physicianName " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "lastVisitDate", valueIf(hasPhysician && samePhysician, appData.health.lastVisitDate, traversePropertiesString(adviceFormData, ['physicianVisit'])), true)) {
        outData.error = "Cannot set lastVisitDate " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "lastVisitReason", valueIf(hasPhysician && samePhysician, appData.health.lastVisitReason, traversePropertiesString(adviceFormData, ['physicianReason'])), true)) {
        outData.error = "Cannot set physicianPhone " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "physicianPhone", valueIf(hasPhysician && samePhysician, appData.health.physicianPhone, traversePropertiesString(adviceFormData, ['physicianPhone'])), true)) {
        outData.error = "Cannot set physicianPhone " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "physicianStreet", valueIf(hasPhysician && samePhysician, appData.health.physicianStreet, traversePropertiesString(adviceFormData, ['physicianAddress'])), true)) {
        outData.error = "Cannot set physicianStreet " + errorSection + (index + 1);
      }
      if (!outData.error && !createString(tempMed, "physicianZip", valueIf(hasPhysician && samePhysician, appData.health.physicianZip, traversePropertiesString(adviceFormData, ['physicianZip'])), true)) {
        outData.error = "Cannot set physicianZip " + errorSection + (index + 1);
      }
      if (outData.error) {
        return true;
      } else {
        appData.health.advice.push(tempMed);
      }

    });
  }

}


// WEBPACK FOOTER //
// ./src/containers/Applications/shared/appConverters/MBA/health.js